import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import get from 'lodash/get';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { ACCOUNT_ID, DP_USER_STATE } from '../common/Constants';
import constants from './SigninConfig';

export class SigninActionFilter extends BaseActionFilter {
    getSigninPageDL(store, data) {
        const { context } = store.getState();

        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        /* istanbul ignore next */
        const rewardTier = TokenProvider.get('DP_REWARDS_TIER') || '';
        /* istanbul ignore next */
        let profileID = TokenProvider.get(ACCOUNT_ID) || '';
        const isGuest = TokenProvider.get(DP_USER_STATE);
        /* istanbul ignore next */
        if (isGuest === '0') {
            profileID = '';
        }

        const signinPageDL = this.updateCommonDigitalData();
        /* istanbul ignore next */
        let associateFlag = signinPageDL.user.profile.profileInfo.associateFlag || 'no';
        signinPageDL.page.pageInfo.pageName = get(data, 'pageName', 'login');
        signinPageDL.page.pageInfo.pageType = constants.WELCOME_PAGE_ID;
        signinPageDL.page.pageInfo.siteSection = constants.siteSection.HOME;
        signinPageDL.page.pageInfo.deviceType = deviceType;
        signinPageDL.page.pageInfo.searchRedirect = '';
        signinPageDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        signinPageDL.page.pageInfo.version = get(
            data,
            'version',
            'apollo 1 2017 redesign yoda account'
        ); // TODO when we have multiple template
        signinPageDL.page.pageInfo.clusterInstance = Cookies.load('DPInstance');
        signinPageDL.page.category = {};
        signinPageDL.page.category.primaryCategory = constants.siteSection.HOME;
        signinPageDL.page.category.subCategory1 = '';
        signinPageDL.page.category.subCategory2 = '';
        signinPageDL.page.category.department = constants.siteSection.HOME;
        signinPageDL.user.profile.profileInfo.profileID = profileID;
        /* istanbul ignore next */
        if (!profileID) {
            associateFlag = '';
            signinPageDL.user.profile.profileInfo.emailOptIn = ''; // "yes or no"
        }
        signinPageDL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        signinPageDL.user.profile.profileInfo.expressCheckoutEnabled = ''; // yes or no
        signinPageDL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        signinPageDL.error = [
            {
                errorDescription: '',
            },
        ];
        return signinPageDL;
    }

    getGroupBPL(store) {
        const { context } = store.getState();

        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        const getGroupBDL = this.updateCommonDigitalData();
        /* istanbul ignore next */
        const associateFlag = getGroupBDL.user.profile.profileInfo.associateFlag || 'no';
        getGroupBDL.page.pageInfo.pageName = 'sign in group-b';
        getGroupBDL.page.pageInfo.pageType = 'rewards';
        getGroupBDL.page.pageInfo.siteSection = 'rewards';
        getGroupBDL.page.pageInfo.deviceType = deviceType;
        getGroupBDL.page.pageInfo.searchRedirect = '';
        getGroupBDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getGroupBDL.page.pageInfo.version = 'apollo 1 2017 redesign yoda account';
        getGroupBDL.page.pageInfo.clusterInstance = Cookies.load('DPInstance');
        getGroupBDL.page.category = {};
        getGroupBDL.page.category.primaryCategory = 'account';
        getGroupBDL.page.category.subCategory1 = '';
        getGroupBDL.page.category.subCategory2 = '';
        getGroupBDL.page.category.department = 'account';
        getGroupBDL.user.profile.profileInfo.profileID = TokenProvider.get(ACCOUNT_ID);
        /* istanbul ignore next */
        const rewardTier =
            TokenProvider.get('DP_REWARDS_TIER') ||
            getGroupBDL.user.profile.profileInfo.rewardsMemberType;
        getGroupBDL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        getGroupBDL.user.profile.profileInfo.visitorID = '';
        getGroupBDL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        getGroupBDL.error = [];
        getGroupBDL.error.push({
            errorDescription: '',
        });

        return getGroupBDL;
    }

    getSigninPageFormErrorPL(error) {
        let signinPageFormErrorDL = this.updateCommonDigitalData();
        signinPageFormErrorDL = {
            error,
        };
        return signinPageFormErrorDL;
    }
}

export default SigninActionFilter;
